import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialConnection = {
    id: 0,
    integration: '',
    integrationId: 0,
    email: '',
    isSendScopeAvailable: false,
    freeCredits: '',
};
const initialState = Object.assign(Object.assign({}, initialConnection), { timestamp: 0, uuid: '', showConnectionSuccess: false });
const slice = createSlice({
    name: 'COMPOSE',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        startSession(state, { payload }) {
            state.uuid = payload.uuid;
            state.timestamp = payload.timestamp;
        },
        setConnection(state, { payload }) {
            state.id = payload.id;
            state.integration = payload.integration;
            state.integrationId = payload.integrationId;
            state.email = payload.email;
            state.isSendScopeAvailable = payload.isSendScopeAvailable;
            state.freeCredits = payload.freeCredits;
        },
        clearConnection(state) {
            Object.assign(state, initialConnection);
        },
        resetFreeCredits(state) {
            state.freeCredits = '';
        },
        setShowSuccessConnection(state, { payload }) {
            state.showConnectionSuccess = payload;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
